import React from 'react';
import './Home.css';
import About from './About';
import Experience from './Experience';
import Skills from './Skills';
import Project from './Project';
import Contact from './Contact';
import BackToTop from './BackToTop';
import Typeright from './Typeright';

const Home = () => {
  return (
    <>
      <section id="home-section" className="hero-section">
        <Typeright />
      </section>
      <section id="about-section" className="site-section">
        <About />
      </section>
      <section id="experience-section" className="site-section">
        <Experience />
      </section>
      <section id="skills-section" className="site-section">
        <Skills />
      </section>
      <section id="projects-section" className="site-section">
        <Project />
      </section>
      <section id="contact-section" className="site-section">
        <Contact />
      </section>
      <BackToTop />
    </>
  );
}

export default Home;
